import {useTranslation} from "react-i18next";
import React from "react";
import {SubscriptionDetailContent} from "../SubscriptionDetail";

const ProgressComparisonBlock = ({ comparisonCards }: { comparisonCards?: SubscriptionDetailContent['comparisonCards'] }) => {
    const { t } = useTranslation();
    if (!comparisonCards || comparisonCards.length < 2) return null;
    const [now, goal] = comparisonCards;
    // Helper to get the best image url
    const getImageUrl = (imgObj: any) => {
        if (!imgObj) return '/images/avatars/male.png';
        if (imgObj.formats?.medium?.url) return imgObj.formats.medium.url;
        if (imgObj.formats?.small?.url) return imgObj.formats.small.url;
        if (imgObj.formats?.thumbnail?.url) return imgObj.formats.thumbnail.url;
        if (imgObj.url) return imgObj.url;
        return '/images/avatars/male.png';
    };
    // Helper for progress bar
    const ProgressBar = ({ value, color, label, isIncome }: { value: number; color: string; label: string; isIncome?: boolean }) => (
        <div className={`comparison-progress-bar${isIncome ? ' comparison-progress-bar-income' : ''}`} style={{ background: color }}>
            <div className={`comparison-progress-thumb${isIncome ? ' comparison-progress-thumb-income' : ''}`} style={{ left: `${value}%` }} />
            <div className={`comparison-progress-tooltip${isIncome ? ' comparison-progress-tooltip-income' : ''}`} style={{ left: `${value}%` }}>{label}</div>
        </div>
    );
    const PartlyProgressBar = ({ value, color, label }: { value: number; color: string; label: string }) => (
        <div className="partly-progress-bar">
            <div
                className="partly-progress-bar-fill"
                style={{ width: `${value}%`, background: color }}
            />
            <div
                className="partly-progress-bar-thumb"
                style={{ left: `${value}%` }}
            />
            <div className="partly-progress-bar-label" style={{ left: `${value}%` }}>{label}</div>
        </div>
    );
    return (
        <>
            <div className="comparison-block">
                <div className="comparison-cols">
                    {/* Now */}
                    <div className="comparison-col">
                        <div className="comparison-label">{now.title}</div>
                        <img src={getImageUrl(now.image)} alt={now.title} className="comparison-img" />
                        <div className="comparison-metric">
                            <div className="comparison-metric-label">{t('subscription.aiSkills')}</div>
                            <ProgressBar value={now.aiSkillsValue} color={'linear-gradient(90deg, #F87171 0%, #FACC15 50%, #22C55E 100%)'} label={now.aiSkillsLabel} isIncome />
                        </div>
                        <div className="comparison-metric">
                            <div className="comparison-metric-label">{t('subscription.incomePotential')}</div>
                            <PartlyProgressBar value={now.incomePotentialValue} color={'linear-gradient(90deg, #FBBF24 0%, #E5E7EB 100%)'} label={t('subscription.limited')}  />
                        </div>
                    </div>
                    {/* Goal */}
                    <div className="comparison-col">
                        <div className="comparison-label">{goal.title}</div>
                        <img src={getImageUrl(goal.image)} alt={goal.title} className="comparison-img" />
                        <div className="comparison-metric">
                            <div className="comparison-metric-label">{t('subscription.aiSkills')}</div>
                            <ProgressBar value={goal.aiSkillsValue} color={'linear-gradient(90deg, #F87171 0%, #FACC15 50%, #22C55E 100%)'} label={goal.aiSkillsLabel} isIncome />
                        </div>
                        <div className="comparison-metric">
                            <div className="comparison-metric-label">{t('subscription.incomePotential')}</div>
                            <PartlyProgressBar value={goal.incomePotentialValue} color={'linear-gradient(90deg, #3B82F6 0%, #3B82F6 100%)'} label={t('subscription.high')} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="comparison-disclaimer">{t('subscription.disclaimer')}</div>
        </>
    );
};

export default ProgressComparisonBlock;
